<template>
    <b-modal
        id="modal-create-survey-question-choice"
        ref="modal-create-survey-question-choice"
        centered
        ok-title="Aceptar"
        ok-variant="primary"
        cancel-title="Cancelar"
        :title="modalTitle"
        :ok-disabled="disableOkButton"
        @ok="onCreateUpdate"
        @hidden="resetForm()"
    >
        <b-form id="survey-question-choice-form" @submit.stop.prevent="onSubmit()">

            <b-form-group
                id="input-group-choice-body"
                label="*Texto:"
                label-for="input-choice-body"
            >
                <b-form-textarea
                    id="input-choice-body"
                    v-model="$v.form.body.$model"
                    name="choice-body"
                    rows="4"
                    trim
                    no-resize
                    :state="validateState('body')"
                    :disabled="formDisabled"
                />
                <b-form-invalid-feedback id="input-choice-body-feedback">
                    <ul>
                        <li v-if="!$v.form.body.required">Este campo es requerido.</li>
                    </ul>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="input-group-choice-isCorrect">
                <b-form-checkbox
                    id="input-choice-isCorrect"
                    v-if="selectedSurveyObject && selectedSurveyObject.isEvaluated"
                    v-model="form.isCorrect"
                    name="choice-isCorrect"
                    size="lg"
                    switch
                    :disabled="formDisabled"
                >
                    ¿Respuesta correcta?
                </b-form-checkbox>
            </b-form-group>

        </b-form>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'QuestionCreateUpdateModal',
    data () {
        return {
            formDisabled: false,
            modalTitle: 'Agregar Nueva Opción',
            form: {
                choiceId: null,
                body: '',
                isCorrect: false
            },
            oldForm: {
                body: '',
                isCorrect: false
            }
        }
    },
    validations: {
        form: {
            body: {
                required
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedCrudObject',
            'selectedSurveyObject',
            'selectedSurveyQuestionId'
        ]),
        disableOkButton () {
            if (this.selectedCrudObject) {
                return this.formDisabled || this.$v.form.$invalid ||
                (this.form.body === this.oldForm.body &&
                this.form.isCorrect === this.oldForm.isCorrect)
            } else {
                return this.formDisabled || this.$v.form.$invalid
            }
        }
    },
    watch: {
        selectedCrudObject (val, oldVal) {
            // If selectedCrudObject is given a value then the form enters Update mode
            // otherwise the form will always be in Create mode
            if (val) {
                this.modalTitle = 'Editar Opción'
                this.form.choiceId = this.selectedCrudObject.id
                this.form.body = this.oldForm.body = this.selectedCrudObject.body
                this.form.isCorrect = this.oldForm.isCorrect = this.selectedCrudObject.isCorrect
            } else {
                this.resetForm()
            }
        }
    },
    methods: {
        ...mapActions([
            'createSiteSurveyQuestionChoice',
            'updateSiteSurveyQuestionChoice',
            'readSingleSiteTeacherSurvey'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onCreateUpdate (bvModalEvt) {
            bvModalEvt.preventDefault() // Prevent modal from closing
            await this.onSubmit() // Trigger submit handler
        },
        resetForm () {
            this.modalTitle = 'Agregar Nueva Opción'
            this.form.choiceId = null
            this.form.body = this.oldForm.body = ''
            this.form.isCorrect = this.oldForm.isCorrect = false
            this.$v.$reset()
            this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            this.$store.commit('RESET_SELECTED_SURVEY_QUESTION_ID')
        },
        async onSubmit () {
            let loader = this.$root.$loading.show()
            try {
                this.formDisabled = true
                const payloadData = {
                    ...this.form,
                    courseSiteId: this.activeSite.id,
                    surveyId: this.selectedSurveyObject.id,
                    surveyQuestionId: this.selectedSurveyQuestionId
                }
                var reloadPayload = { courseSiteId: this.activeSite.id, surveyId: this.selectedSurveyObject.id }
                if (this.selectedCrudObject) {
                    // Update mode
                    await this.updateSiteSurveyQuestionChoice(payloadData)
                    await this.readSingleSiteTeacherSurvey(reloadPayload)
                    this.$root.infoToast(`Opción editada.`)
                } else {
                    // Create mode
                    await this.createSiteSurveyQuestionChoice(payloadData)
                    await this.readSingleSiteTeacherSurvey(reloadPayload)
                    this.$root.successToast(`Opción creada exitosamente.`)
                }
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-create-survey-question-choice')
                })
                this.resetForm()
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
